import { useState } from 'react';
import {
  sendLoginOtp,
  verifyLoginOtp,
} from '../auth/huakyaAuth';
import { userFacingErrorMessage } from '../lib/userFacingError';

export function LoginPage() {
  const [country, setCountry] = useState<'IN' | 'US'>('IN');
  const [phone, setPhone] = useState('');
  const devFixedOtp =
    import.meta.env.VITE_FIREBASE_PROJECT_ID === 'huakya-dev' ? '111111' : '';
  const [otp, setOtp] = useState(devFixedOtp);
  const [step, setStep] = useState<'phone' | 'otp'>('phone');
  const [verificationId, setVerificationId] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const dial = country === 'IN' ? '+91' : '+1';

  async function onSend() {
    setErr(null);
    const digits = phone.replace(/\D/g, '');
    if (country === 'IN' && digits.length !== 10) {
      setErr('Enter a valid 10-digit mobile number');
      return;
    }
    if (country === 'US' && digits.length !== 10) {
      setErr('Enter a valid 10-digit mobile number');
      return;
    }
    setBusy(true);
    try {
      const vid = await sendLoginOtp(`${dial}${digits}`);
      setVerificationId(vid);
      setOtp(devFixedOtp);
      setStep('otp');
    } catch (e: unknown) {
      setErr(userFacingErrorMessage(e, { fallback: 'Sign-in failed. Please try again.' }));
    } finally {
      setBusy(false);
    }
  }

  async function onVerify() {
    setErr(null);
    if (otp.trim().length < 4) {
      setErr('Enter the OTP');
      return;
    }
    setBusy(true);
    try {
      await verifyLoginOtp(verificationId, otp.trim());
    } catch (e: unknown) {
      setErr(userFacingErrorMessage(e, { fallback: 'Sign-in failed. Please try again.' }));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-screen">
    <div
      style={{
        minHeight: '100%',
        background: 'linear-gradient(180deg, #e8f2ff 0%, #f5f7fb 40%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 400,
          background: '#fff',
          borderRadius: 16,
          padding: 28,
          boxShadow: '0 8px 40px rgba(0,50,120,0.08)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 8 }}>
          <img src="/huakya_logo.png" alt="" width={96} height={96} style={{ borderRadius: 20 }} />
        </div>
        <h1 style={{ textAlign: 'center', fontSize: 22, margin: '12px 0 4px' }}>
          HuaKya
        </h1>
        <p style={{ textAlign: 'center', color: 'var(--hk-muted)', marginBottom: 24 }}>
          Sign in with your mobile number
        </p>

        {step === 'phone' ? (
          <>
            <label style={{ fontSize: 13, color: 'var(--hk-muted)' }}>Country</label>
            <select
              className="hk-input"
              style={{ marginBottom: 12 }}
              value={country}
              onChange={(e) => setCountry(e.target.value as 'IN' | 'US')}
            >
              <option value="IN">India (+91)</option>
              <option value="US">United States (+1)</option>
            </select>
            <label style={{ fontSize: 13, color: 'var(--hk-muted)' }}>Mobile number</label>
            <input
              className="hk-input"
              style={{ marginBottom: 8 }}
              inputMode="numeric"
              autoComplete="tel"
              placeholder={country === 'IN' ? '9876543210' : '2025550100'}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            {err && (
              <p style={{ color: '#c00', fontSize: 14, margin: '8px 0' }}>{err}</p>
            )}
            <button
              type="button"
              className="hk-btn"
              style={{ width: '100%', marginTop: 8 }}
              disabled={busy}
              onClick={() => void onSend()}
            >
              {busy ? 'Sending…' : 'Continue'}
            </button>
          </>
        ) : (
          <>
            <p style={{ fontSize: 14, color: 'var(--hk-muted)', marginBottom: 12 }}>
              {devFixedOtp
                ? `Dev code ${devFixedOtp}. No SMS is sent.`
                : `Enter the OTP sent to ${dial} ••••${phone.slice(-3)}`}
            </p>
            <input
              className="hk-input"
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder="OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            {err && (
              <p style={{ color: '#c00', fontSize: 14, margin: '8px 0' }}>{err}</p>
            )}
            <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
              <button
                type="button"
                className="hk-btn-ghost"
                onClick={() => {
                  setStep('phone');
                  setOtp('');
                  setErr(null);
                }}
              >
                Back
              </button>
              <button
                type="button"
                className="hk-btn"
                style={{ flex: 1 }}
                disabled={busy}
                onClick={() => void onVerify()}
              >
                {busy ? 'Verifying…' : 'Verify'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
    </div>
  );
}
